import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext"; // adjust path if needed

export default function Login() {
    const navigate = useNavigate();
    const { user } = useContext(AuthContext); // assuming AuthContext stores `user` or similar

    useEffect(() => {
        if (user) {
            // logged in → send to dashboard
            navigate("/dashboard", { replace: true });
        } else {
            // not logged in → send to homepage
            navigate("/", { replace: true });
        }
    }, [navigate, user]);

    return null;
}
